import React, { useEffect, useState } from "react";
import axios from "axios";
import "./followups.css";

// ── helpers ──────────────────────────────────────────────
function getTodayLocal() {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm   = String(now.getMonth() + 1).padStart(2, "0");
  const dd   = String(now.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function getCurrentTimeLocal() {
  const now  = new Date();
  const hh   = String(now.getHours()).padStart(2, "0");
  const min  = String(now.getMinutes()).padStart(2, "0");
  return `${hh}:${min}`;
}
// ─────────────────────────────────────────────────────────

function Followups() {

  const [data, setData]           = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [meetingForm, setMeetingForm] = useState({
    company_name: "",
    client_name:  "",
    address:      "",
    meeting_date: "",
    meeting_time: ""
  });

  const userId   = localStorage.getItem("userId");
  const role     = localStorage.getItem("role");
  const userName = localStorage.getItem("name");

  const todayStr = getTodayLocal();
  const minTime  = meetingForm.meeting_date === todayStr ? getCurrentTimeLocal() : "";

  // ================= FETCH =================
  const fetchFollowups = async () => {
    try {
      const token = localStorage.getItem("token");
      const res   = await axios.get(
        "http://localhost:5000/api/followups",
        { headers: { Authorization: "Bearer " + token } }
      );
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // ================= OPEN MODAL =================
  const openModal = (customerName = "") => {
    setMeetingForm({
      company_name: "",
      client_name:  customerName,
      address:      "",
      meeting_date: getTodayLocal(),
      meeting_time: getCurrentTimeLocal(),
    });
    setShowModal(true);
  };

  // ================= VALIDATION =================
  const validateMeeting = () => {
    if (
      !meetingForm.company_name ||
      !meetingForm.client_name  ||
      !meetingForm.meeting_date ||
      !meetingForm.meeting_time
    ) {
      alert("All fields are required ⚠️");
      return false;
    }

    const selectedDateTime = new Date(
      `${meetingForm.meeting_date}T${meetingForm.meeting_time}`
    );
    if (selectedDateTime < new Date()) {
      alert("Past date/time not allowed ❌");
      return false;
    }

    return true;
  };

  // ================= SAVE MEETING =================
  const saveMeeting = async () => {
    if (!validateMeeting()) return;

    try {
      await axios.post("http://localhost:5000/api/meetings/create", {
        ...meetingForm,
        user_id:   userId,
        user_role: role,
        user_name: userName,
      });

      alert("Meeting Scheduled ✅");
      setShowModal(false);
      fetchFollowups();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFollowups();
  }, []);

  return (
    <div className="followup-page">

      <h3 style={{ marginBottom: "15px" }}>Followup Calls</h3>

      <div style={{ overflowX: "auto" }}>
        <table className="call-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Meeting</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.customer_name}</td>
                <td>{item.phone}</td>

                {/* ✅ FIXED: was item.call_status */}
                <td>{item.followup_status}</td>

                <td>
                  <button
                    className="meeting-btn"
                    onClick={() => openModal(item.customer_name)}
                  >
                    Schedule
                  </button>
                </td>

                {/* ✅ FIXED: was item.call_date → now item.followup_date
                    Strip Z so MySQL UTC string doesn't shift to wrong day in IST */}
                <td>
                  {item.followup_date
                    ? new Date(
                        item.followup_date.replace("T", " ").replace(/\.000Z$/, "")
                      ).toLocaleString("en-IN")
                    : "—"}
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= MODAL ================= */}
      {showModal && (
        <div className="note-modal">
          <div className="note-box">

            <div className="note-header">
              <span>Schedule Meeting</span>
              <button onClick={() => setShowModal(false)}>X</button>
            </div>

            <div style={{ padding: "12px" }}>

              <input
                placeholder="Company Name"
                value={meetingForm.company_name}
                onChange={(e) =>
                  setMeetingForm({ ...meetingForm, company_name: e.target.value })
                }
              />

              <input
                placeholder="Client Name"
                value={meetingForm.client_name}
                onChange={(e) =>
                  setMeetingForm({ ...meetingForm, client_name: e.target.value })
                }
              />

              <input
                placeholder="Address"
                value={meetingForm.address}
                onChange={(e) =>
                  setMeetingForm({ ...meetingForm, address: e.target.value })
                }
              />

              <input
                type="date"
                value={meetingForm.meeting_date}
                min={todayStr}
                onChange={(e) =>
                  setMeetingForm({ ...meetingForm, meeting_date: e.target.value })
                }
              />

              <input
                type="time"
                value={meetingForm.meeting_time}
                min={minTime}
                onChange={(e) =>
                  setMeetingForm({ ...meetingForm, meeting_time: e.target.value })
                }
              />

              <button className="save-btn" onClick={saveMeeting}>
                Save Meeting
              </button>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Followups;